import { render, staticRenderFns } from "./deleted-dx-report.vue?vue&type=template&id=304b0b09"
import script from "./deleted-dx-report.vue?vue&type=script&lang=ts"
export * from "./deleted-dx-report.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports